import { COURSE_COVER, COURSE_COVER_FALLBACK, COURSE_COVER_TRACK_COLOR, CourseCoverSize } from '../../constants/course-cover';
import { CircularProgress } from '../circular-progress/circular-progress';

export interface CourseCoverProps {
  imageUrl: string | null;
  /** `lg` is the user card, `sm` the admin list — all derived from the same ratio. */
  size?: CourseCoverSize;
  /** Full ring by default: admin views have no progress to show, the sweep is decorative. */
  percentage?: number;
  animate?: 'none' | 'forward';
  alt?: string;
}

/**
 * Course cover in the shared geometry. Wraps CircularProgress rather than redrawing the ring, so the
 * inner shadow, gradient and sweep are the real ones — a copy would silently drift from the original.
 */
const CourseCover = ({ imageUrl, size = 'sm', percentage = 100, animate = 'forward', alt = '' }: CourseCoverProps) => {
  const { size: outer, strokeWidth } = COURSE_COVER[size];

  return (
    <CircularProgress
      size={outer}
      strokeWidth={strokeWidth}
      percentage={percentage}
      bgColor="#ffffff"
      bgTrackColor={COURSE_COVER_TRACK_COLOR}
      imgUrl={imageUrl ?? COURSE_COVER_FALLBACK}
      imgAlt={alt}
      animate={animate}
    />
  );
};

export default CourseCover;
